module.exports = __webpack_public_path__ + "img/Nectios-icon.36d22739.svg";